import { useCallback } from 'react';
import { spliceToken, tokenAtOffset, tokenKeyIntent } from './tokens';
export function useTokenizedInput(param) {
    let { inputRef, onChange, pattern, onTokenClick } = param;
    const setValueWithCaret = useCallback((param)=>{
        let { value, caret } = param;
        const input = inputRef.current;
        if (!input) return;
        input.value = value;
        onChange(value);
        requestAnimationFrame(()=>{
            if (inputRef.current !== input) return;
            input.focus();
            input.setSelectionRange(caret, caret);
        });
    }, [
        inputRef,
        onChange
    ]);
    const insertToken = useCallback((label)=>{
        var _input_selectionStart, _input_selectionEnd;
        const input = inputRef.current;
        if (!input) return;
        const selectionStart = (_input_selectionStart = input.selectionStart) !== null && _input_selectionStart !== void 0 ? _input_selectionStart : input.value.length;
        const selectionEnd = (_input_selectionEnd = input.selectionEnd) !== null && _input_selectionEnd !== void 0 ? _input_selectionEnd : selectionStart;
        setValueWithCaret(spliceToken({
            text: input.value,
            label,
            selectionStart,
            selectionEnd
        }));
    }, [
        inputRef,
        setValueWithCaret
    ]);
    const onKeyDown = useCallback((event)=>{
        var _input_selectionStart, _input_selectionEnd;
        const input = inputRef.current;
        if (!input) return undefined;
        const selectionStart = (_input_selectionStart = input.selectionStart) !== null && _input_selectionStart !== void 0 ? _input_selectionStart : 0;
        const intent = tokenKeyIntent({
            text: input.value,
            key: event.key,
            selectionStart,
            selectionEnd: (_input_selectionEnd = input.selectionEnd) !== null && _input_selectionEnd !== void 0 ? _input_selectionEnd : selectionStart,
            shiftKey: event.shiftKey,
            modifierKey: event.ctrlKey || event.metaKey,
            pattern
        });
        if (!intent) return undefined;
        event.preventDefault();
        if (intent.type === 'moveCaret') input.setSelectionRange(intent.to, intent.to);
        if (intent.type === 'select') input.setSelectionRange(intent.start, intent.end, intent.direction);
        if (intent.type !== 'openTrigger') return undefined;
        input.value = intent.textWithoutBrace;
        onChange(intent.textWithoutBrace);
        return {
            at: intent.at,
            anchorEl: input
        };
    }, [
        inputRef,
        onChange,
        pattern
    ]);
    const onClick = useCallback(()=>{
        var _input_selectionStart;
        const input = inputRef.current;
        if (!input) return;
        const token = tokenAtOffset({
            text: input.value,
            offset: (_input_selectionStart = input.selectionStart) !== null && _input_selectionStart !== void 0 ? _input_selectionStart : 0,
            pattern
        });
        if (!token) return;
        input.setSelectionRange(token.start, token.end);
        onTokenClick === null || onTokenClick === void 0 ? void 0 : onTokenClick({
            label: token.label,
            anchorEl: input
        });
    }, [
        inputRef,
        onTokenClick,
        pattern
    ]);
    return {
        onKeyDown,
        onClick,
        insertToken,
        setValueWithCaret
    };
}
